<!-- :no-close-on-backdrop="true"
      :close-on-esc="true" -->
<template>
  <div>
    {{ this.ChecklogIn() }}
    <b-modal
      v-model="show"
      id="modal-login"
      ref="modal-login"
      title="Login Form"
      :hide-header="true"
      hide-footer
      :no-close-on-backdrop="true"
      :close-on-esc="true"
    >
      <template>
        <div class="text-center margin-bottom8px">
          <h5 style="display: none;">Login Form</h5>
          <img alt="PjHIS" src="../assets/PjHIS.png" />
        </div>
      </template>

      <b-form @submit="LogformSubmit">
        <b-alert
          variant="danger"
          class="margin-bottom"
          :show="$store.get('systems@ErrorMessageApi') !== ''"
          >{{ $store.get("systems@ErrorMessageApi") }}</b-alert
        >

        <b-container class="bv-example-row">
          <b-row class="my-1">
            <b-col cols="12">
              <b-form-group
                label-cols="3"
                label-cols-lg="2"
                label-size="sm"
                label="Username"
                label-for=""
              >
                <b-form-input
                  type="text"
                  size="sm"
                  id="username"
                  v-model="form.username"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col cols="12">
              <b-form-group
                label-cols="3"
                label-cols-lg="2"
                label-size="sm"
                label="Password"
                label-for=""
              >
                <b-form-input
                  type="password"
                  size="sm"
                  id="password"
                  v-model="form.password"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="my-1 text-right">
            <b-col cols="12">
              <b-button
                size="sm"
                type="submit"
                variant="success"
                @click="LogformSubmit"
              >
                Login (ลงชื่อเข้าใช้)
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import store from "@/store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSession from "vue-session";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

const cryptoJSON = require("crypto-json");
const algorithm = "camellia-128-cbc";
const encoding = "hex";

Vue.use(VueSession);

@Component({
  component: {
    store,
    axios,
    VueAxios,
    thaiDatetime,
    pjFunctions
  },
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      show: false,
      form: {
        username: "",
        password: ""
      },
      ApiKey: "",
      CloseFalse: false
    };
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods);
  },
  mounted() {
    if (this.$session.get("LoginStatus")) {
      const LogIndata = this.$session.get("LoginData");
      const password = "hisSMPK10685";

      const algorithm = "aes256";
      const encoding = "hex";
      const keys = [
        "hospCode",
        "hospName",
        "userName",
        "ApiKey",
        "DoctorCode",
        "UserId",
        "groupname",
        "vn_str",
        "an_str",
        "hn_str",
        "hos_accessright",
        "entryposition",
        "accessright",
        "user_id",
        "modul",
        "DID",
        "LID"
      ];

      const output = cryptoJSON.decrypt(LogIndata, password, {
        encoding,
        keys,
        algorithm
      });

      var myip = require("quick-local-ip");

      if (myip.getLocalIP4() == output.LID) {
        store.set("systems@ApiKey", output.ApiKey);
        store.set("systems@LoginStatus", true);
        store.set("systems@LoginData", output);
        store.set("systems@ErrorMessageApi", "");
        store.set("systems@ErrorMessageApiStatus", false);
      } else {
        let currentObj = this;
        store.set("systems@LoginStatus", false);
        store.set("systems@LoginData", []);
        store.set("systems@ApiKey", "");
        this.$session.destroy();
        currentObj.show = false;
      }
    }

    if (localStorage.name) {
      this.ApiKey = this.$store.get("systems@ApiKey");
    }
  },
  methods: {
    ChecklogIn() {
      /*
      if (
        this.$store.get("systems@ApiKey") <= "" ||
        this.$store.get("systems@ApiKey") == "undefined" ||
        this.$store.get("systems@ApiKey") == null
      ) {
        this.show = true;
        this.$bvModal.show("modal-login");
      } else {
        this.show = false;
        this.$bvModal.hide("modal-login");
      }
      */
      if (
        this.$session.get("LoginStatus") <= "" ||
        this.$session.get("LoginStatus") == "undefined" ||
        this.$session.get("LoginStatus") == null
      ) {
        this.show = true;
        this.$bvModal.show("modal-login");
      } else {
        this.show = false;
        this.$bvModal.hide("modal-login");
      }
    },
    LogformSubmit(e) {
      e.preventDefault();
      // console.log(this.$store.getters.UrlApi+'UserAuthen')

      let pwd = this.form.password;

      if (
        pwd <= "" ||
        pwd.length < 4 ||
        pwd == "3210" ||
        pwd == "4321" ||
        pwd == "54321" ||
        pwd == "654321" ||
        pwd == "7654321" ||
        pwd == "87654321" ||
        pwd == "987654321" ||
        pwd == "1234" ||
        pwd == "12345" ||
        pwd == "123456" ||
        pwd == "1234567" ||
        pwd == "12345678" ||
        pwd == "123456789" ||
        pwd == "0123"
      ) {
        // ssss
        pwd = "";
      }

      let currentObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "UserAuthenNew", {
          CompanyId: this.$store.get("systems@CompanyId"),
          UserId: this.form.username,
          PassWord: pwd
        })
        .then(function(response) {
          currentObj.output = response.data;
          if (currentObj.output.status === true) {
            // store.commit('setLoginStatus', true)
            // store.commit('setLoginData', currentObj.output.result)
            // store.commit('setErrorMessageApi', '')
            // store.commit('setErrorMessageApiStatus', false)

            // localStorage.ApiKey = currentObj.output.result.ApiKey
            store.set("systems@ApiKey", currentObj.output.result.ApiKey);
            store.set("systems@LoginStatus", true);
            store.set("systems@LoginData", currentObj.output.result);
            store.set("systems@ErrorMessageApi", "");
            store.set("systems@ErrorMessageApiStatus", false);

            currentObj.$session.start();
            currentObj.$session.set("LoginStatus", true);
            // currentObj.$session.set("LoginData", currentObj.output.result);

            const password = "hisSMPK10685";
            const input = currentObj.output.result;

            const algorithm = "aes256";
            const encoding = "hex";
            const keys = [
              "hospCode",
              "hospName",
              "userName",
              "ApiKey",
              "DoctorCode",
              "UserId",
              "groupname",
              "vn_str",
              "an_str",
              "hn_str",
              "hos_accessright",
              "entryposition",
              "accessright",
              "user_id",
              "modul",
              "DID",
              "LID"
            ];

            let tnow = new Date();

            let Days = "";
            let Months = "";
            let Hours = "";
            let Minutes = "";
            let Seconds = "";

            if (tnow.getDate().toString().length == 1) {
              Days = "0" + tnow.getDate().toString();
            } else {
              Days = tnow.getDate().toString();
            }

            if ((tnow.getMonth() + 1).toString().length == 1) {
              Months = "0" + (tnow.getMonth() + 1).toString();
            } else {
              Months = (tnow.getMonth() + 1).toString();
            }

            let DateNow = tnow.getFullYear() + "-" + Months + "-" + Days;

            if (tnow.getHours().toString().length == 1) {
              Hours = "0" + tnow.getHours().toString();
            } else {
              Hours = tnow.getHours().toString();
            }

            if (tnow.getMinutes().toString().length == 1) {
              Minutes = "0" + tnow.getMinutes().toString();
            } else {
              Minutes = tnow.getMinutes().toString();
            }

            if (tnow.getSeconds().toString().length == 1) {
              Seconds = "0" + tnow.getSeconds().toString();
            } else {
              Seconds = tnow.getSeconds().toString();
            }

            input.DID = DateNow + " " + Hours + ":" + Minutes + ":" + Seconds;

            let myip = require("quick-local-ip");
            input.LID = myip.getLocalIP4();

            const output = cryptoJSON.encrypt(input, password, {
              encoding,
              keys,
              algorithm
            });

            currentObj.$session.set("LoginData", output);

            currentObj.show = false;
            currentObj.form.username = "";
            currentObj.form.password = "";

            if (currentObj.$store.get("systems@ApiKey")) {
              setTimeout(() => {
                currentObj.loadMophApiImmigrationGetToken();
              }, 1000);
            }
          } else {
            // store.commit('setLoginStatus', false)
            // store.commit('setLoginData', [])
            // store.commit('setErrorMessageApi', currentObj.output.ErrorMessage)
            // store.commit('setErrorMessageApiStatus', true)
            store.set("systems@LoginStatus", false);
            store.set("systems@LoginData", []);
            store.set(
              "systems@ErrorMessageApi",
              currentObj.output.ErrorMessage
            );
            store.set("systems@ErrorMessageApiStatus", true);
          }
          // console.log(currentObj.output.result)
        })
        .catch(function(error) {
          currentObj.output = error;
          // store.commit('setLoginStatus', false)
          // store.commit('setLoginData', [])
          // store.commit('setErrorMessageApi', currentObj.output)
          // store.commit('setErrorMessageApiStatus', true)

          store.set("systems@LoginStatus", false);
          store.set("systems@LoginData", []);
          store.set("systems@ErrorMessageApi", currentObj.output);
          store.set("systems@ErrorMessageApiStatus", true);
        });
    },

    loadMophApiImmigrationGetToken() {
      let DataLoadObj = this;
      let data = [];
      let val = null;
      let st = "Y";

      // #### Moph api immigration get token ####
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "moph-api-immigration-get-token",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey")
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          // console.log("sss", DataLoadObj.output);
          if (DataLoadObj.output.status === true) {
            if (DataLoadObj.output.result.use_status != "") {
              store.set("systems@mophUser", DataLoadObj.output.result);
            }
            if (DataLoadObj.output.result.use_status == "N") {
              st = DataLoadObj.output.result.use_status;
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("Moph api immigration get token : " + DataLoadObj.output);
        })
        .finally(function() {
          DataLoadObj.$store.get("systems@mophUser");
          if (st == "N") {
            DataLoadObj.loadMophApiImmigrationGenToken();
          }
        });
    },

    loadMophApiImmigrationGenToken() {
      let DataLoadObj = this;
      let data = [];
      let val = null;
      let password = this.$store.get("systems@mophUser").moph_password;
      let username = this.$store.get("systems@mophUser").moph_username;
      let mophData = null;

      // #### Moph api immigration ####
      this.axios
        .post(
          "https://smarthealth.service.moph.go.th/phps/public/api/v3/gettoken",
          {
            password: password,
            username: username
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.jwt_token !== "") {
            mophData = DataLoadObj.output;
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("Moph api immigration : " + DataLoadObj.output);
        })
        .finally(function() {
          if (mophData !== null && mophData !== "") {
            DataLoadObj.loadMophApiImmigrationPostToken(mophData);
          }
        });
    },

    loadMophApiImmigrationPostToken(mophData) {
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### moph-api-immigration-post-token ####

      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "moph-api-immigration-post-token",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            mophData: mophData
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            if (DataLoadObj.output.result.use_status !== "") {
              store.set("systems@mophUser", DataLoadObj.output.result);
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("Moph api immigration get token : " + DataLoadObj.output);
        });
    }
  }
})
export default class Login extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}
</style>

